
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"20","height":"20","rx":"10","fill":"#7A48AC","fill-opacity":".15"}}),_c('path',{attrs:{"d":"M14.53 7.688v6.558c0 .782-.577 1.416-1.301 1.416H7.596c-.725 0-1.302-.634-1.302-1.416V5.754a1.47 1.47 0 01.393-.999c.249-.265.587-.415.94-.417h3.878c.099 0 .197.021.287.062.091.04.174.1.243.175l2.275 2.541c.14.153.22.358.22.572z","stroke":"#7A48AC","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.441 4.338v2.453a.643.643 0 00.636.635h2.452","stroke":"#7A48AC","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('g',{attrs:{"clip-path":"url(#clip0_14249_5131)"}},[_c('path',{attrs:{"d":"M9.826 9.158c.26-.468.39-.702.586-.702.195 0 .325.234.586.702l.067.12c.075.134.112.2.17.244.057.044.129.06.273.093l.13.03c.507.114.76.171.82.365.061.194-.112.396-.457.8l-.09.104c-.097.114-.146.172-.168.243-.022.07-.015.147 0 .3l.013.14c.053.538.079.808-.08.927-.157.12-.394.01-.868-.207l-.123-.057c-.135-.062-.202-.093-.273-.093-.072 0-.139.031-.274.093l-.122.056c-.475.219-.712.328-.87.208-.157-.12-.131-.389-.079-.927l.014-.14c.015-.153.022-.23 0-.3-.022-.071-.071-.129-.17-.243l-.089-.105c-.345-.403-.517-.605-.457-.8.06-.193.313-.25.82-.365l.13-.03c.145-.032.216-.048.274-.092.058-.044.095-.11.17-.243l.067-.121z","fill":"#7A48AC"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_14249_5131"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(8.353 8.456)","d":"M0 0h4.118v4.118H0z"}})])])])
          )
        }
      }
    